import { render } from "./QuestionPage.vue?vue&type=template&id=27b0038e&scoped=true&ts=true"
import script from "./QuestionPage.vue?vue&type=script&lang=ts"
export * from "./QuestionPage.vue?vue&type=script&lang=ts"

import "./QuestionPage.vue?vue&type=style&index=0&id=27b0038e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b0038e"]])

export default __exports__